import React from 'react'
import _ from 'lodash'
import PropTypes from 'prop-types'

const ErrorList = ({ errors }) => {
  const listItems = _.map(_.castArray(errors), (error, index) => (
    <li key={index}>
      {error}
    </li>
  ))

  return (
    <ul className="list--no-list-style" style={_.some(errors) ? {} : { display: 'none' }}>
      {listItems}
    </ul>
  )
}

ErrorList.propTypes = {
  errors: PropTypes.array
}

ErrorList.defaultProps = {
  errors: []
}

export default ErrorList
